export default __webpack_public_path__ + "static/media/heroLogin.50c5b7e9.png";